export const FETCH_DATA = 'REBOOK';
export const REBOOK_FETCH_DATA_REQUEST = `${FETCH_DATA}_REQUEST`;
export const REBOOK_FETCH_DATA_SUCCESS = `${FETCH_DATA}_SUCCESS`;
export const REBOOK_FETCH_DATA_FAILURE = `${FETCH_DATA}_FAILURE`;
